import { addLocale, locale } from 'primereact/api';

export const setupPrimeReactLocale = (lang: 'es' | 'en') => {
  if (lang === 'es') {
    addLocale('es', {
      accept: 'Sí',
      addRule: 'Agregar regla',
      am: 'AM',
      apply: 'Aplicar',
      cancel: 'Cancelar',
      choose: 'Elegir',
      chooseDate: 'Elegir fecha',
      chooseMonth: 'Elegir mes',
      chooseYear: 'Elegir año',
      clear: 'Limpiar',
      contains: 'Contiene',
      custom: 'Personalizado',
      dateAfter: 'Fecha posterior a',
      dateBefore: 'Fecha anterior a',
      dateFormat: 'dd/mm/yy',
      dateIs: 'La fecha es',
      dateIsNot: 'La fecha no es',
      dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
      dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
      dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
      emptyFilterMessage: 'No se encontraron resultados',
      emptyMessage: '',
      endsWith: 'Termina con',
      equals: 'Igual a',
      fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      filter: 'Filtrar',
      firstDayOfWeek: 1,
      gt: 'Mayor que',
      gte: 'Mayor o igual que',
      lt: 'Menor que',
      lte: 'Menor o igual que',
      matchAll: 'Coincidir todo',
      matchAny: 'Coincidir cualquiera',
      medium: 'Medio',
      monthNames: [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre',
      ],
      monthNamesShort: [
        'ene',
        'feb',
        'mar',
        'abr',
        'may',
        'jun',
        'jul',
        'ago',
        'sep',
        'oct',
        'nov',
        'dic',
      ],
      nextDecade: 'Próxima década',
      nextHour: 'Próxima hora',
      nextMinute: 'Próximo minuto',
      nextMonth: 'Próximo mes',
      nextSecond: 'Próximo segundo',
      nextYear: 'Próximo año',
      noFilter: 'Sin filtro',
      notContains: 'No contiene',
      notEquals: 'No es igual a',
      now: 'Ahora',
      passwordPrompt: 'Ingrese una contraseña',
      pending: 'Pendiente',
      pm: 'PM',
      prevDecade: 'Década anterior',
      prevHour: 'Hora anterior',
      prevMinute: 'Minuto anterior',
      prevMonth: 'Mes anterior',
      prevSecond: 'Segundo anterior',
      prevYear: 'Año anterior',
      reject: 'No',
      removeRule: 'Eliminar regla',
      startsWith: 'Empieza con',
      strong: 'Fuerte',
      today: 'Hoy',
      upload: 'Subir',
      weak: 'Débil',
      weekHeader: 'Sem',
      aria: {
        cancelEdit: 'Cancelar edición',
        close: 'Cerrar',
        collapseRow: 'Fila colapsada',
        editRow: 'Editar fila',
        expandRow: 'Fila expandida',
        falseLabel: 'Falso',
        filterConstraint: 'Restricción de filtro',
        filterOperator: 'Operador de filtro',
        firstPageLabel: 'Primera página',
        gridView: 'Vista de cuadrícula',
        hideFilterMenu: 'Ocultar menú de filtros',
        jumpToPageDropdownLabel: 'Ir a página (desplegable)',
        jumpToPageInputLabel: 'Ir a página (entrada)',
        lastPageLabel: 'Última página',
        listLabel: 'Lista de opciones',
        listView: 'Vista de lista',
        moveAllToSource: 'Mover todo al origen',
        moveAllToTarget: 'Mover todo al destino',
        moveBottom: 'Mover al final',
        moveDown: 'Mover abajo',
        moveToSource: 'Mover al origen',
        moveToTarget: 'Mover al destino',
        moveTop: 'Mover al principio',
        moveUp: 'Mover arriba',
        navigation: 'Navegación',
        next: 'Siguiente',
        nextPageLabel: 'Página siguiente',
        nullLabel: 'No seleccionado',
        pageLabel: 'Página {page}',
        otpLabel: 'Ingrese el carácter {0} del código',
        previous: 'Anterior',
        prevPageLabel: 'Página anterior',
        rotateLeft: 'Girar a la izquierda',
        rotateRight: 'Girar a la derecha',
        rowsPerPageLabel: 'Filas por página',
        saveEdit: 'Guardar edición',
        scrollTop: 'Desplazarse arriba',
        selectAll: 'Todos los elementos seleccionados',
        selectRow: 'Fila seleccionada',
        showFilterMenu: 'Mostrar menú de filtros',
        slide: 'Diapositiva',
        slideNumber: 'Diapositiva {slideNumber}',
        star: '1 estrella',
        stars: '{star} estrellas',
        trueLabel: 'Verdadero',
        unselectAll: 'Todos los elementos deseleccionados',
        unselectRow: 'Fila deseleccionada',
        zoomImage: 'Ampliar imagen',
        zoomIn: 'Acercar',
        zoomOut: 'Alejar',
      },
    });
    locale('es');
  } else {
    locale('en');
  }
};
